import { render, staticRenderFns } from "./UserMoney.vue?vue&type=template&id=8190d506&scoped=true&"
import script from "./UserMoney.vue?vue&type=script&lang=js&"
export * from "./UserMoney.vue?vue&type=script&lang=js&"
import style0 from "./UserMoney.vue?vue&type=style&index=0&id=8190d506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8190d506",
  null
  
)

export default component.exports